<script>
import { mapGetters, mapState } from 'vuex'
import BreadCrumbs from '@components/breadcrumbs/breadcrumbs-wrapper.vue'
import cloneDeep from 'lodash/cloneDeep'
import Translate from '@components/translate'
import { validationMixin } from 'vuelidate'
import { dateTimeFormatters } from '@src/utils/date-formatters'
const { formatDateWithLocale, formatCurrentDateWithLocale } = dateTimeFormatters()
export default {
  data () {
    return {
      updatingProfile: false,
      error: '',
      name: '',
      userClone: null
    }
  },
  props: {
    hideRouterView: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  components: {
    BreadCrumbs,
    Translate
  },
  mixins: [validationMixin],
  validations: {
    userClone: {
      profile: {
        phone: {
          isPhone (value) {
            if (value) {
              return /^(?=(?:^(?:\+?1\s*(?:[.-]\s*)?)?(?!(?:(?:.*\(.*)|(?:.*\).*)))(?:[2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|(?:.*\((?:[2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\).*))(?:\+?1\s*(?:[.-]\s*)?)?(?:\(?([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\)?)\s*(?:[.-]\s*)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d{1,15}))?$/.test(
                value
              ) // phone valid
            } else return true
          }
        }
      }
    }
  },
  mounted () {
    if (this.user) {
      this.userClone = cloneDeep(this.user)
    }
  },
  computed: {
    ...mapState(['user', 'home', 'settings', 'challenges', 'challengePage']),
    ...mapGetters(['primaryColor', 'primaryColorRgb', 'loggedIn']),
    userAvatar () {
      return this.user &&
        this.user &&
        this.user.profile &&
        this.user.profile.image &&
        this.user.profile.image !== ''
        ? this.user.profile.image
        : require('@assets/placeholder-avatar.png')
    },
    userName () {
      return this.user &&
      this.user.profile &&
      this.user.profile.name
    },
    joinedOn () {
      return this.user && this.user.joined_on && this.user.joined_on > 0 ? formatDateWithLocale(this.user.joined_on, this.$store.state.locale, 'MMMM YYYY') : formatCurrentDateWithLocale(this.$store.state.locale, 'MMMM YYYY')
    }
  },
  methods: {
    async update () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        console.log('Update Profile', this.userClone)
        this.updatingProfile = true
        delete this.userClone.password
        const response = await this.$store.dispatch('updateUser', this.userClone)
        if (response && response.data && response.data.success) {
          await this.$store.dispatch('getUser', this.userClone.token)
          this.updatingProfile = false
        } else {
          this.error = response && response.data ? response.data.message : 'Something went wrong'
          this.updatingProfile = false
        }
      }
    }
  },
  watch: {
    'userClone.profile.phone' (val) {
      this.$v.$reset()
    }
  }
}
</script>

<template>
  <div class="info-container" :style="{ '--BGColor': `rgba(${primaryColorRgb}, ${1})`}">
     <BreadCrumbs class="second" v-if="!hideRouterView && isMobile" @back="$emit('hide-router-view')" />
     <b-col>
        <b-form v-if="userClone" @submit.prevent="update">
          <div class="row avatar-container">
            <div class="col user-avatar">
              <span class="image-wrapper"><img :src="userAvatar" /></span>
              <div>
                <span class="name">{{userName}}</span>
                <span class="date"><Translate directive="profile.membersince" /> {{joinedOn}}</span>
              </div>
            </div>
          </div>
          <b-form-group
            id="input-group-2"
            label-for="input-2"
          >
            <label><Translate directive="profile.fullname" /></label>
            <b-form-input
              v-if="userClone"
              id="input-1"
              v-model="userClone.profile.name"
              type="text"
              required
              :placeholder="this.$_polyglot.t('profile.fullname')"
            ></b-form-input>
          </b-form-group>
         <div class="row">
           <div class="col">
             <b-form-group
            id="input-group-1"
            label-for="input-1"
          >
            <label><Translate directive="profile.email" /></label>
            <b-form-input
              v-if="userClone"
              id="input-1"
              v-model="userClone.email"
              type="email"
              required
              :placeholder="this.$_polyglot.t('profile.email')"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
           </div>
           <div class="col">
             <b-form-group
            id="input-group-3"
            label-for="input-3"
          >
            <label><Translate directive="profile.phone" /></label>
            <b-form-input
              v-if="userClone"
              id="input-3"
              v-model="userClone.profile.phone"
              type="text"
              placeholder="(000) 000-0000"
              :state="!$v.userClone.profile.phone.$error"
            ></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Enter a valid phone number
            </b-form-invalid-feedback>
          </b-form-group>
           </div>
         </div>
          <BaseButton type="submit" :disabled="updatingProfile" class="button btn-primary submit">
            <b-spinner v-show="updatingProfile" small type="grow"></b-spinner>
            <span v-show="!updatingProfile"><Translate directive="profile.formsubmit" /></span>
          </BaseButton>
          </b-form>
      </b-col>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.info-container {
  padding: 3rem 4.5%;
  width: 100%;
  .breadcrumb-wrapper {
    margin-bottom: 0.1rem;
    align-self: flex-start;
    margin-left: -0.5rem;
    &.second {
      position: absolute;
      left: 0.5rem;
      top: 0.5rem;
    }
    ::v-deep span {
      img {
        margin-right: 0.2rem;
      }
      h5 {
        font-size: 1.2rem;
      }
    }
  }
  .avatar-container {
  margin-top: 1rem;
  .btn-secondary {
    color: black;
    border: 2px solid var(--BGColor);
    height: 2.5rem;
    padding: 0rem 1.4rem;
    font-size: 1rem;
    &:hover {
      background-color: var(--BGColor);
    }
  }
  .user-avatar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-right: unset;
    padding-left: unset;
    margin-bottom: 2rem;
    div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 1rem;
    }
    .image-wrapper {
      width: 3.5rem;
      height: 3.5rem;
      // cursor: pointer;
      img {
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 50%;
        // cursor: pointer;
      }
      // &:hover {
      //   &::after {
      //     content: '';
      //     position: absolute;
      //     width: 3.5rem;
      //     height: 3.5rem;
      //     border-radius: 50%;
      //     // top: 4px;
      //     left: 0;
      //     right: 0;
      //     background-image: linear-gradient(rgba(black, 0.1), rgba(black, 0.1));
      //     z-index: 1;
      //   }
      // }
    }
    .name {
      font-family: $base-font-family;
      font-style: normal;
      font-weight: 800;
      font-size: 25px;
      line-height: 25px;
      letter-spacing: -0.761905px;
      text-transform: capitalize;
    }
    .date {
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 18px;
      text-transform: capitalize;
      color: rgba(0, 0, 0, 0.49);
    }
  }
}
  .btn-primary {
    color: white;
    border: 2px solid black;
    background-color: black;
    height: 2.5rem;
    padding: 0rem 1.4rem;
    border-radius: 2rem;
    font-size: 1rem;
    font-weight: 600;
    min-width: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background-color: white;
      color: black;
    }
  }
}
label {
  font-family: $base-font-family;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.1px;
  text-transform: capitalize;
  margin-bottom: unset;
}
input {
  border: unset;
  background-color: #F3F3F3;
  border-radius: 8px;
  transition: 0.3s all ease-in-out;
  min-width: 250px;
  &:focus {
    // border: 1px var(--BGColor) solid;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset, 0px 0px 5px var(--BGColor);
  }
  &:disabled {
    background-color: white;
  }
}
textarea:hover,
input:hover,
textarea:active,
input:active,
textarea:focus,
input:focus,
button:focus,
button:active,
button:hover,
label:focus,
.btn:active,
.btn.active
{
  outline:0px !important;
  -webkit-appearance:none;
}

.is-valid {
  background-image: none;
  &:focus {
    // border: 1px var(--BGColor) solid;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset, 0px 0px 5px var(--BGColor);
  }
}
</style>
